// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1FLsd","messages":"Chat_messages__16JjJ","dateDivider":"Chat_dateDivider__3GeXl"};